export default (date) => (
  date ? new Date(date).toLocaleString(
    document.documentElement.lang || 'en',
    {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    },
  ) : ''
);
